import { ClientInfo } from "types/app";
import ActionTypes from "./globalFilter.types";

export const updateTopFilter = (filterObj: any) => ({
  type: ActionTypes.UPDATE_TOP_FILTER,
  payload: filterObj,
});

export const updateTopFilterValues = (filterObj: any) => ({
  type: ActionTypes.UPDATE_TOP_FILTER_VALUES,
  payload: filterObj,
});

export const setExceptionFilter = (filterObj: any) => ({
  type: ActionTypes.UPDATE_TOP_FILTER,
  payload: filterObj,
});

export const setClientID = (action: { clientId: number }) => ({
  type: ActionTypes.CLIENT_ID,
  payload: action,
});

export const setClient = (action: { clientInfo: Partial<ClientInfo> }) => {
  return {
    type: ActionTypes.CLIENT_INFO,
    payload: action,
  };
};

export const clear = () => ({
  type: ActionTypes.CLEAR,
});

export const updateFilterBlockHeight = (height: any) => ({
  type: ActionTypes.UPDATE_FILTER_BLOCK_HEIGHT,
  payload: height,
});
